import styles from "./StatisticsReservationDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import {
  PaymentTypesLabels,
  StatisticDetailItemType,
  CommissionCategoryLabels,
} from "../../../common/labels";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { Tag } from "../../../common/components/common/Tag/Tag";
import { getStatus } from "../../planner/event/utils/PlannerEventStatusUtility";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { constructPlannerEventHref } from "../../../common/infrastructure/routes/routePaths";
import { PriceDisplay } from "../../../common/components/PriceDisplay/PriceDisplay";
import { PaymentTypes } from "../../../common/enums";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";

interface IStatisticsPlanDialogProps {
  item: IStatisticDetailedItemViewModel;
}

export const StatisticsReservationDialog = ({
  item,
}: IStatisticsPlanDialogProps) => {
  const navigate = useNavigate();

  const { color: statusColor, label: statusLabel, additionalTag } = getStatus(
    true,
    item.reservationStatus,
    item.isCancelled,
    item.pricePaidInEur
  );

  const onClick = () => {
    if (!item.eventId) {
      return;
    }

    const link = constructPlannerEventHref(item.eventId);
    navigate(link);
  };

  // The currency is no longer appended here — the amount itself carries it.
  const paymentTypeLabel = item.paymentType
    ? PaymentTypesLabels[item.paymentType]
    : "Неплатено";

  const hasCommission =
    item.commissionAmountInEur !== null &&
    item.commissionAmountInEur !== undefined;

  const commissionCategoryLabel =
    item.commissionCategory !== null && item.commissionCategory !== undefined
      ? CommissionCategoryLabels[item.commissionCategory]
      : "";

  const commissionPercentLabel =
    item.commissionPercent !== null && item.commissionPercent !== undefined
      ? `${item.commissionPercent}%`
      : "";

  const commissionTypeValue = [commissionCategoryLabel, commissionPercentLabel]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName} <span>(#{item.userId})</span>
          </h5>
          <p>
            Дата на събитие:{" "}
            <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
        <div className={styles.root_header_right}>
          <div>
            <Tag
              className={classNames(styles.root_header_right_tag)}
              label={statusLabel}
              backgroundColor={statusColor}
            />
            <RenderWhen condition={!!additionalTag}>
              <Tag
                className={classNames(styles.root_header_right_tag)}
                label={additionalTag?.label ?? ""}
                backgroundColor={additionalTag?.color ?? ""}
              />
            </RenderWhen>
          </div>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"СЪБИТИЕ"}
          value={`${item.name} (#${item.eventId})`}
        />
        <RenderWhen condition={item.paymentType !== PaymentTypes.Multisport}>
          <StatisticsDialogKeyValueItem
            name={"ПЛАТЕНА СУМА"}
            value={
              !!item.pricePaid ? (
                <PriceDisplay
                  minPrice={item.pricePaid}
                  currencyId={item.currencyId}
                />
              ) : (
                "Неплатено"
              )
            }
          />
        </RenderWhen>
        <StatisticsDialogKeyValueItem
          name={"НАЧИН НА ПЛАЩАНЕ"}
          value={paymentTypeLabel}
        />
        <StatisticsDialogKeyValueItem
          name={"ТИП ТРАНЗАКЦИЯ"}
          value={StatisticDetailItemType[item.type]}
        />
        {hasCommission && (
          <>
            <StatisticsDialogKeyValueItem
              name={"КОМИСИОНЕН ПРОЦЕНТ"}
              value={commissionTypeValue || "—"}
            />
            <StatisticsDialogKeyValueItem
              name={"СПЕЧЕЛЕНА КОМИСИОННА"}
              value={`€ ${(item.commissionAmountInEur ?? 0).toFixed(2)}`}
            />
          </>
        )}
      </div>
    </div>
  );
};
